import { render, staticRenderFns } from "./nav-learning-worldwide.vue?vue&type=template&id=239da4d2"
import script from "./nav-learning-worldwide.ts?vue&type=script&lang=ts&external"
export * from "./nav-learning-worldwide.ts?vue&type=script&lang=ts&external"
import style0 from "./nav-learning-worldwide.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports